import { render, staticRenderFns } from "./disposalProgress.vue?vue&type=template&id=2187bc89&scoped=true"
import script from "./disposalProgress.vue?vue&type=script&lang=js"
export * from "./disposalProgress.vue?vue&type=script&lang=js"
import style0 from "./disposalProgress.vue?vue&type=style&index=0&id=2187bc89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2187bc89",
  null
  
)

export default component.exports